import Vue from 'vue'
import delayTouch from '../mixins/vuelidate-delay-touch'
import breakpoints from '../mixins/breakpoints'
import lang from '../mixins/lang'

Vue.mixin(delayTouch)
Vue.mixin(breakpoints)
Vue.mixin(lang)
